import React, { useState } from "react";
import "./data-exchange-comment.component.scoped.scss";
import { Box, Typography } from "@material-ui/core";
import { icons } from "../../../../../../statics/icons";
import {
  formatDate,
  showPopupToastMsg,
  showToastMsg,
} from "../../../../../../helpers";
import { useTranslation } from "react-i18next";
import { DataExchangeService } from "../../../../../../services/data-exchange.services";
import { ConfirmDialog } from "../../../../../../dialogs/confirm-dialog/confirm-dialog";

const DataExchangeCommentComponent = (props: any) => {
  const { comment, onDelete } = props;
  const { t } = useTranslation();
  const dataExchangeService = new DataExchangeService();

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [userImageError, setUserImageError] = useState(false);

  const handleClose = (value: any) => {
    setTimeout(() => {
      setShowConfirmModal(false);
    }, 0);
    if (value) {
      deleteComment();
    }
  };

  const deleteComment = async () => {
    const response = await dataExchangeService.delete(comment.id);
    if (response.message === "SUCCESS") {
      onDelete(comment.id);
      showToastMsg("success", t("COMMENT_DELETED_SUCCESSFULLY"));
    } else {
      showPopupToastMsg("error", t("SOME_THING_WENT_WRONG"));
    }
  };

  return (
    <Box className="comment_content">
      <Box
        className="d-flex justify-content-between"
        style={{ minHeight: "5rem", position: "relative", gap: "1rem" }}
      >
        <Box className="info">
          <Box className="icon-wrapper-circle file_up">
            <img src={icons.FILE_UP} alt="file-up" />
          </Box>
          <Box className="content">
            <Box className="user mb-3">
              <Box className="user__profile__pic">
                {comment.user.profilePicURL && !userImageError ? (
                  <img
                    src={comment.user.profilePicURL || icons.PLACEHOLDER.user}
                    title={comment.user.firstName + " " + comment.user.lastName}
                    alt=""
                    onError={setUserImageError.bind(null, true)}
                  />
                ) : (
                  <span className="text-uppercase">
                    {comment.user.firstName
                      ? comment.user.firstName[0] + comment.user.lastName[0]
                      : ""}
                  </span>
                )}
              </Box>

              <Box>
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: 500, lineHeight: "22px" }}
                >
                  <Typography variant="body1">
                    {comment.user && typeof comment.user === "object"
                      ? comment.user.firstName + " " + comment.user.lastName
                      : "Anonymous"}
                  </Typography>
                </Typography>
                <Typography variant="body2" style={{ color: "#808080" }}>
                  {formatDate(comment.createdAt, "dddd, DD.MM.YYYY, HH:mm")}
                </Typography>
              </Box>
            </Box>
            <CommentData comment={comment} />
            <Box className="mb-3">
              {comment.files.map((file: any, index: number) => {
                return <FileContent key={index} file={file} />;
              })}
            </Box>
          </Box>
        </Box>
        <Box className="actions d-flex" style={{ gap: ".5rem" }}>
          {/* <Box className="edit icon-wrapper-circle">
            <img src={icons.EDIT_WHITE} alt="" />
          </Box> */}
          <Box
            className="delete icon-wrapper-circle"
            onClick={setShowConfirmModal.bind(null, true)}
          >
            <img src={icons.delete} alt="" />
          </Box>
        </Box>
      </Box>
      {showConfirmModal && (
        <ConfirmDialog
          show={showConfirmModal}
          onClose={handleClose}
          dialogTitle={t("confirm delete")}
          dialogBody={t("are you sure you want to delete the comment")}
          confirmBtnText={t("delete")}
          cancelBtn={true}
        />
      )}
    </Box>
  );
};

const CommentData = (props: any) => {
  const { comment } = props;
  return (
    <Box className="comment_data mb-3">
      <Box className="comment">
        <Typography variant="body1" color="textPrimary">
          {comment.content}
        </Typography>
        <Typography variant="body2" style={{ color: "#808080" }}>
          {formatDate(comment.createdAt, "DD.MM.YYYY, HH:mm")}
        </Typography>
      </Box>
    </Box>
  );
};

const FileContent = (props: any) => {
  const { t } = useTranslation();
  const { file } = props;

  const downloadFile = () => {
    const a = document.createElement("a");
    a.href = file.url;
    a.target = "_blank";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <Box className="file_content mb-2">
      <Box className="file_info">
        <Typography
          variant="subtitle2"
          className="d-flex align-items-center mb-1"
          style={{ fontWeight: 400 }}
        >
          <img src={icons.FILE_UP} alt="file-up" className="mr-2" />
          {file.name}
        </Typography>
        <Box className="d-flex" style={{ gap: "1rem" }}>
          <Typography variant="body2" style={{ color: "#78829D" }}>
            {t("FILE_TYPE")}{" "}
            <strong style={{ color: "var(--primary-text)" }}>
              {file.type}
            </strong>
          </Typography>
          <Typography variant="body2" style={{ color: "#78829D" }}>
            {t("FILE_SIZE")}{" "}
            <strong style={{ color: "var(--primary-text)" }}>
              {file.size}
            </strong>
          </Typography>
        </Box>
      </Box>
      <span className="download" onClick={downloadFile}>
        {t("DOWNLOAD")}
      </span>
    </Box>
  );
};

export default DataExchangeCommentComponent;
